import { render } from "./ModalAddFavorite.vue?vue&type=template&id=39445a6e&scoped=true"
import script from "./ModalAddFavorite.vue?vue&type=script&lang=js"
export * from "./ModalAddFavorite.vue?vue&type=script&lang=js"

import "./ModalAddFavorite.vue?vue&type=style&index=0&id=39445a6e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39445a6e"]])

export default __exports__